<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <div class="row align-items-center">
      <div class="col-md-12 align-items-center">
        <p-panel [header]="'onboardingGalleryPersonalDetails.yourProfile' | transloco" [toggleable]="false">
          <!-- Inside the ng-template pTemplate="icons" for the "Profile Data" tab -->
          <form class="form-horizontal" #artistForm="ngForm">
            <!-- Profile Image Section -->
            <div class="form-group mt-2 d-flex flex-column align-items-center">
              <!-- <ng-container *ngIf="!formData.ImgUrl">
              <label for="formFile" class="form-label">Gallery Logo</label>
              <input class="form-control" type="file" id="formFile" name="LogoFile"
                (change)="onFileSelected($event)" />
              </ng-container> -->
              @if (!formData.ImgUrl) {
                <div class="input-group justify-content-center">
                  <p-fileUpload  #fileUpload name="LogoFile"
                    (onSelect)="onFileSelected($event.files)"
                  [chooseLabel]="'onboardingGalleryPersonalDetails.profileImage' | transloco" [auto]="true" mode="basic"></p-fileUpload>
                </div>
              }
              @if (formData.ImgUrl) {
                <div class="position-relative d-inline-block mt-2 mb-3 text-center">
                  <!-- Display uploaded image with rounded corners and shadow -->
                  <img [src]="formData.ImgUrl ? formData.ImgUrl : 'assets/images/No-Image.png'"
                    class="dsGalleryLogo rounded-circle shadow"
                    style="width: 200px; height: 200px; object-fit: cover;" />
                    <div class="position-absolute top-0 end-0 m-2">
                      <button type="button" class="btn btn-sm btn-outline-danger p-button-outlined"
                        (click)="removeImg()">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                }
              </div>


              <div class="row mt-2">
                <!-- Artist Name -->
                <div class="col-6">
                  <div class="form-group">
                    <label for="FirstName" class="form-label"><span class="text-danger">*</span>
                  {{ 'onboardingGalleryPersonalDetails.firstName' | transloco }}</label>
                  <input type="text" id="FirstName" class="form-control"
                    [(ngModel)]="formData.FirstName" name="FirstName" [placeholder]="'onboardingGalleryPersonalDetails.enterFirstName' | transloco"
                    required />
                  </div>
                </div>
                <!-- Email -->
                <div class="col-6">
                  <div class="form-group">
                    <label for="LastName" class="form-label">
                    {{ 'onboardingGalleryPersonalDetails.lastName' | transloco }}</label>
                    <input type="text" id="LastName" class="form-control"
                      [(ngModel)]="formData.LastName" name="LastName" [placeholder]="'onboardingGalleryPersonalDetails.enterLastName' | transloco"
                      required />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="email" class="form-label"><span class="text-danger">*</span>
                {{ 'onboardingGalleryPersonalDetails.email' | transloco }}</label>
                <input id="email" type="email" class="form-control" [(ngModel)]="formData.Email"
                  name="email" [placeholder]="'onboardingGalleryPersonalDetails.enterEmail' | transloco" required disabled="disabled" />
                </div>
                <div class="row mt-2">
                  <div class="col-6">
                    <!-- Phone Number -->
                    <div class="form-group ">
                      <label for="phoneNumber" class="form-label">{{ 'onboardingGalleryPersonalDetails.phoneNumber' | transloco }}</label>
                      <input id="phoneNumber" type="tel" class="form-control"
                        [(ngModel)]="formData.PhoneNumber" name="phoneNumber"
                        [placeholder]="'onboardingGalleryPersonalDetails.enterPhoneNumber' | transloco" />
                      </div>
                    </div>
                    <div class="col-6">
                      <!-- Mobile Number -->
                      <div class="form-group ">
                        <label for="MobileNumber" class="form-label">{{ 'onboardingGalleryPersonalDetails.mobileNumber' | transloco }}</label>
                        <input id="MobileNumber" type="tel" class="form-control"
                          [(ngModel)]="formData.MobileNumber" name="MobileNumber"
                          [placeholder]="'onboardingGalleryPersonalDetails.enterMobileNumber' | transloco" />
                        </div>
                      </div>
                    </div>

                    <!-- Your Staff  -->
                    @if (authConfig.IsGallery) {
                      <div class="form-group mt-3 mb-2">
                        <p-panel [header]="'onboardingGalleryPersonalDetails.yourStaff' | transloco" [toggleable]="true">
                          <div class="table-responsive mt-3">
                            <app-gallery-staff></app-gallery-staff>
                          </div>
                        </p-panel>
                      </div>
                    }

                    <!-- Social links -->
                    @if (!authConfig.IsAdministrator) {
                      <div class="form-group mt-3 mb-2">
                        <p-panel [header]="'onboardingGalleryPersonalDetails.socialLinks' | transloco" [toggleable]="true">
                          <div class="row">
                            <div class="col-6">
                              <!-- Bank Name -->
                              <div class="form-group ">
                                <label for="FaceBook" class="form-label">Facebook</label>
                                <input type="url" id="FaceBook" pInputText placeholder="Facebook"
                                  class="form-control form-control-sm" [(ngModel)]="formData.FacebookLink"
                                  name="FaceBook" />
                                </div>
                              </div>
                              <div class="col-6">
                                <!-- InstagramLink -->
                                <div class="form-group ">
                                  <label for="Instagram" class="form-label">Instagram</label>
                                  <input type="url" id="InstagramLink" pInputText placeholder="Instagram"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="formData.InstagramLink" name="InstagramLink" />
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-6">
                                  <!-- Linkedin -->
                                  <div class="form-group">
                                    <label for="Linkedin" class="form-label">Linkedin</label>
                                    <input type="url" id="LinkedinLink" pInputText placeholder="Linkedin"
                                      class="form-control form-control-sm" [(ngModel)]="formData.LinkedinLink"
                                      name="LinkedinLink" />
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="form-group">
                                      <label for="Website" class="form-label">{{ 'onboardingGalleryPersonalDetails.website' | transloco }}</label>
                                      <input type="url" id="Website" pInputText [placeholder]="'onboardingGalleryPersonalDetails.website' | transloco"
                                        class="form-control form-control-sm" [(ngModel)]="formData.Website"
                                        name="Website" />
                                      </div>
                                    </div>
                                  </div>
                                </p-panel>
                              </div>
                            }

                            @if (authConfig.IsGallery) {
                              <div class="form-group mt-3 mb-2">
                                <p-panel [header]="'onboardingGalleryPersonalDetails.yourAddresses' | transloco" [toggleable]="true">
                                  <app-view-gallery-address [galleryAddresses]="galleryItems.GalleryAddresses" [galleryId]="galleryItems.Id || ''"
                                    (onAddressChanged)="editGalleryAddress($event)">
                                  </app-view-gallery-address>
                                </p-panel>
                              </div>
                            }

                            @if (authConfig.IsGallery && formData.Gallery) {
                              <div class="form-group mt-3 mb-2">
                                <p-panel [header]="'onboardingGalleryPersonalDetails.businessInformation' | transloco" [toggleable]="true">
                                  <div class="row">
                                    <div class="col-12">
                                      <div class="form-group mt-2">
                                        <label for="BusinessName" class="form-label">{{ 'onboardingGalleryPersonalDetails.businessName' | transloco }}</label>
                                        <input id="businessName" type="text" class="form-control"
                                          [(ngModel)]="formData.BusinessName" name="BusinessName"
                                          [placeholder]="'onboardingGalleryPersonalDetails.businessName' | transloco" />
                                        </div>
                                        <div class="form-group mt-2">
                                          <label class="form-label">{{ 'onboardingGalleryPersonalDetails.galleryType' | transloco }}</label>
                                          <p-dropdown [options]="items" [(ngModel)]="formData.Gallery.GalleryType"
                                            [placeholder]="'onboardingGalleryPersonalDetails.selectGalleryType' | transloco" name="galleryType"
                                          [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="p-2">
                                      <div class="form-group">
                                        <label for="saleType" class="form-label">{{ 'onboardingGalleryPersonalDetails.saleType' | transloco }}</label>
                                        <div class="d-flex justify-content-start">
                                          <div class="d-flex align-items-center">
                                            <input type="radio" name="GallerySaleType" value="Consignment"
                                              [(ngModel)]="formData.Gallery.GallerySaleType"
                                              id="saleTypeAsConsignment">
                                              <label for="saleTypeAsConsignment" class="ms-1">{{ 'onboardingGalleryPersonalDetails.consignment' | transloco }}</label>
                                            </div>
                                            <div class="d-flex align-items-center ms-3">
                                              <input type="radio" name="GallerySaleType" value="WholeSale"
                                                [(ngModel)]="formData.Gallery.GallerySaleType"
                                                id="saleTypeAsWholeSale">
                                                <label for="saleTypeAsWholeSale" class="ms-1">{{ 'onboardingGalleryPersonalDetails.wholesale' | transloco }}</label>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row mt-2">
                                            <div class="col-6">
                                              <div class="form-group me-3">
                                                <label for="galleryCommission" class="form-label">{{ 'onboardingGalleryPersonalDetails.commission' | transloco }}</label>
                                                <p-dropdown [options]="commissionOptions"
                                                  [(ngModel)]="formData.Gallery.CommissionPercentage"
                                                name="galleryCommission" [style]="{'width':'100%'}"></p-dropdown>
                                              </div>
                                            </div>
                                            <div class="col-6">
                                              <div class="form-group me-3">
                                                <label for="gallerySalesTax" class="form-label">{{ 'onboardingGalleryPersonalDetails.salesTax' | transloco }}</label>
                                                <input type="number" class="form-control "
                                                  [(ngModel)]="formData.Gallery.SalesTaxPercentage"
                                                  [style]="{'width':'282px'}" name="gallerySalesTax" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row mt-2">
                                              <div class="col-6">
                                                <div class="form-group me-3">
                                                  <label for="terms" class="form-label mt-1">{{ 'onboardingGalleryPersonalDetails.terms' | transloco }}</label>
                                                  <p-dropdown [options]="terms" [(ngModel)]="formData.Gallery.Terms"
                                                    [placeholder]="'onboardingGalleryPersonalDetails.selectTerms' | transloco" name="terms"
                                                  [style]="{'width':'100%'}"></p-dropdown>
                                                </div>
                                              </div>
                                              <div class="col-6">
                                                <div class="form-group">
                                                  <label for="galleryABN" class="form-label">{{ 'onboardingGalleryPersonalDetails.abn' | transloco }}</label>
                                                  <input type="text" class="form-control"
                                                    [(ngModel)]="formData.Gallery.ABN" name="galleryABN" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="row mt-2">
                                                <div class="form-group">
                                                  <p-checkbox name="addGST" [binary]="true" [label]="'onboardingGalleryPersonalDetails.addGst' | transloco"
                                                  [(ngModel)]="formData.Gallery.AddGST"></p-checkbox>
                                                </div>
                                                @if (formData.Gallery.AddGST) {
                                                  <div class="form-group mt-2">
                                                    <label for="gstId" class="form-label">{{ 'onboardingGalleryPersonalDetails.gstId' | transloco }}</label>
                                                    <input type="text" class="form-control" [(ngModel)]="formData.Gallery.GstId"
                                                      [placeholder]="'onboardingGalleryPersonalDetails.gstId' | transloco" name="gstId" id="gstId" />
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                            </p-panel>
                                          </div>
                                        }
                                      </form>
                                    </p-panel>
                                  </div>
                                </div>
                              </div>

                              <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                                <button class="btn btn-outline-secondary" routerLink="/">{{ 'onboardingGalleryPersonalDetails.skip' | transloco }}</button>
                                <button class="btn btn-outline-secondary" (click)="updateProfile()">{{ 'onboardingGalleryPersonalDetails.saveAndNext' | transloco }}</button>
                              </div>
                            </div>


                            <!-- IMAGE CROPPER COMPONENT SELECTER -->
                            @if (showCropperDialog) {
                              <app-image-cropper [image]="currentSelectedImageToCrop" [showCropperDialog]="showCropperDialog"
                                (onImageCropped)="onImageCropped($event)" (onImageCropperClose)="onImageCropperClose($event)">
                              </app-image-cropper>
                            }